<template>
  <div class="system-builder__contact-info--section">
    <div class="system-builder__contact-info--container">
      <h4>Submit the form below to find and get a quote from a local dealer!</h4>
      <input type="text" value="" name="full-name" maxlength="70" placeholder="Full Name*"
             v-model="sharedState.customerDetails.customerName"
             onchange="this.className=(this.value=='')?'':'visited'" @focus="toggleNav" @blur="toggleNav" required>

      <input type="email" value="" maxlength="70" placeholder="Email*" name="user-email"
             v-model="sharedState.customerDetails.customerEmail"
             onchange="this.className=(this.value=='')?'':'visited'" @focus="toggleNav" @blur="toggleNav" required>

      <input type="text" value="" maxlength="20" placeholder="Zip Code*" name="user-zip"
             v-model="sharedState.customerDetails.customerZip" onchange="this.className=(this.value=='')?'':'visited'"
             @focus="toggleNav" @blur="toggleNav" required>

      <span v-if="showPhoneHelp" style="color:red;font-size:14px;">Please enter a valid phone number, including the area code.</span>
      <input type="text" value="" maxlength="30" placeholder="Phone* (with area code)" name="user-phone"
             v-model="sharedState.customerDetails.customerPhone"
             onchange="this.className=(this.value=='')?'':'visited'" @focus="toggleNav" @blur="toggleNav" required>
    </div>
    <transition name="fade">
      <div class="system-builder__contact-info--cta-container">
        <span class="contact-form-help-message" v-if="showHelpMessage">*Complete required fields.</span>
        <button class="button__solid--blue" @click="{$emit('submitContactForm')}" v-if="showButton">Find a Dealer</button>
        <button class="button__outline--disabled" @click="showHelpMessage = true" v-else>Find a Dealer</button>
      </div>
    </transition>
  </div>
</template>

<script>
  import store from '../../store'
  import footerNav from '../reusable/stickyFooterNavigation.vue'
  import postalCodes from 'postcode-validator'
  import PhoneNumber from 'awesome-phonenumber'

  export default {
    components: {footerNav},
    name: 'contactInfo',
    data () {
      return {
        sharedState: store.state,
        showButton: false,
        showHelpMessage: false,
        showPhoneHelp: false
      }
    },
    methods: {
      checkCanadianPostal (postal) {
        var canadaRegex = new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i)
        if (canadaRegex.test(postal)) {
          return true
        } else {
          return false
        }
      },
      checkFormValidation () {
        var customerEmail = this.sharedState.customerDetails.customerEmail
        var customerName = this.sharedState.customerDetails.customerName
        var customerPhone = this.sharedState.customerDetails.customerPhone
        var customerZip = this.sharedState.customerDetails.customerZip

        var isZipValid = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(customerZip)

        if (this.checkCanadianPostal(customerZip)) {
          isZipValid = true
        }

        // Validate phone number
        if (customerPhone !== '' && customerZip !== '') {
          // If phone & zip value exists, validate phone number
          // Get country code from zip
          var isValidUS = postalCodes.validate('us', customerZip)
          var isValidCA = postalCodes.validate('ca', customerZip)

          var regionCode = ''

          if (isValidUS === true) {
            // Zip is from US
            regionCode = 'US'
          } else if (isValidCA === true) {
            // Zip is from CA
            regionCode = 'CA'
          }

          var pn = new PhoneNumber(customerPhone, regionCode)
          var isPhoneValid = pn.isValid()
        }

        if (customerEmail && customerName !== '' && isPhoneValid && isZipValid) {
          this.showButton = true
          this.showHelpMessage = false

          // Format phone number and update
          var formattedPhoneNumber = pn.getNumber('international')
          store.updatePhoneNumber(formattedPhoneNumber)

          this.showPhoneHelp = false
        } else {
          if (isPhoneValid === false) {
            this.showPhoneHelp = true
          }

          this.showButton = false
        }
      }
    },
    mounted: function () {
      this.checkFormValidation()
    },
    updated: function () {
      this.checkFormValidation()
    }
  }
</script>



// WEBPACK FOOTER //
// ContactInfo.vue?f1c4152a